<template>
  <div style="max-width: 100%; margin: auto;">
    <!-- <v-system-bar color="amber lighten-1">
      <span style="direction: ltr">{{time}}</span>
      <v-icon>mdi-battery</v-icon> -->
    <!--      <v-icon>mdi-signal-cellular-outline</v-icon>-->
    <!--      <v-icon>mdi-wifi-strength-4</v-icon>-->
    <!-- <v-spacer></v-spacer>
    </v-system-bar> -->

    <div class="ma-auto">
      <div class="d-flex align-center my-4">
        <!-- <h1>1</h1> -->
        <v-btn to="/" color="transparent" elevation="0">
          <img src="@/assets/images/icons/chevron-right.svg" style="width: 40px" />
        </v-btn>
        <h3 style="margin-right: -18px;">تاکسی 133</h3>
      </div>
    </div>
    <!--<span>-->
    <!--{{tem_load}}-->
    <!--</span>-->
    <div class="chatpage" @scroll="scroll" ref="chatpage">

      <div v-for="(MessagesLists, index) in MessagesList" :key="index">
        <div v-if="MessagesLists.owner == 'me'" color="rgba(0,0,0,0)" flat class="mb-8 px-3 "
          style="display: flex;align-items: center;gap: 3px">
          <v-spacer></v-spacer>
          <v-card width="65%" color="blue" dark>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="mb-4">{{ MessagesLists.content }}</div>
                <v-list-item-subtitle>{{ MessagesLists.created_at_fa }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>

          <v-avatar class="mt-n5 mr-2" size="30" elevation="10">
            <img :src="MessagesLists.avatar" />
          </v-avatar>

        </div>
        <div v-if="MessagesLists.owner == 'you'" color="rgba(0,0,0,0)" flat class="mb-8 "
          style="display: flex;align-items: center;gap: 3px">

          <v-avatar class="mt-n5 ml-2" size="30" elevation="10">
            <img :src="MessagesLists.avatar" />
          </v-avatar>

          <v-card width="65%" color="green" dark>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="mb-4">{{ MessagesLists.content }}</div>
                <v-list-item-subtitle>{{ MessagesLists.created_at_fa }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <v-btn color="black" icon class="mb-n10">
            <v-icon>fas fa-ellipsis-h</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-text-field v-model="message" rounded filled :maxlength="400" label="متن پیام را وارد کنید" type="text">
      <v-icon v-if="!message" slot="append">mdi-microphone</v-icon>
      <v-icon v-if="!message" slot="append">mdi-emoticon</v-icon>
      <v-icon v-if="message && !loading" slot="append" style="cursor: pointer" @click="send_pm()">mdi-send</v-icon>
      <v-icon v-if="loading" size="30" slot="append" color="">mdi-loading mdi-spin</v-icon>
    </v-text-field>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import SocketListner from "../components/SocketListner.vue";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";
export default {
  computed: {
    ...mapGetters(['baseUrl', "auth"]),
  },
  components: {
    SocketListner,
    AndroidGeolocation,
   },
  data() {
    return {
      MessagesList: [],
      userBox: '',
      message: '',
      PageShow: 1,
      time: '',
      loading: false,
      tem_load: false,
      loadmore: true,
    }
  },

  mounted() {
    let self = this;
    self.getInfo();
    self.ReloadPage();
    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
  },
  methods: {
    scroll(e) {

      if (!this.loadmore) {
        return
      }
      const { target } = e;



      if (Math.ceil(target.scrollTop) == (target.offsetHeight - target.scrollHeight)) {
        this.ReloadPage('scroll')
      }
    },
    clearMessage() {
      this.message = ''
    },
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
      // console.log(this.userBox)
    },
    ReloadPage(state) {
      this.checkmsg()
      if (state === 'scroll') {
        this.PageShow += 1
        console.log('sc')
      }
      else {
        this.MessagesList = [];
        this.PageShow = 1;
      }


      fetch(this.baseUrl + '/chat-list?token=' + this.userBox.token +
        '&public_token=' + this.userBox.public_token + '&uid=' + this.userBox.uid +
        '&page=' + this.PageShow)
        .then(response => response.json())
        .then(json => {
          console.log('ss', json.data.list)
          if (json.result == '0') {
            this.PageShow -= 1
          }
          else if (json.result == '1') {
            // if (!state) {
            //    this.MessagesList=[];
            //
            // }
            this.MessagesList = this.MessagesList.concat(json.data.list);
            // this.MessagesList= json.data.list;

            console.log('qqqqqqq', this.MessagesList)
            if (json.data.total_page === this.PageShow) {
              this.loadmore = false
            }
          }

          this.tem_load = !this.tem_load
        })

    },
    checkmsg() {

      fetch(this.baseUrl + '/check-message?token=' + this.userBox.token +
        '&public_token=' + this.userBox.public_token + '&uid=' + this.userBox.uid +
        '&page=' + this.PageShow)
        .then(response => response.json())
        .then(json => {
          console.log('ss', json)

        })

    },
    send_pm() {
      let self = this;
      this.loading = true
      let newParam = {};
      newParam.token = this.userBox.token;
      newParam.message = this.message;
      newParam.uid = this.userBox.uid;
      newParam.public_token = this.userBox.public_token;
      this.helperPost('chat-insert', newParam).then(function (r) {
        if (r.data.result === '1') {
          self.ReloadPage();
          self.message = '';
        }
        self.loading = false
      }).catch(function () {
        self.loading = false
      })
    }
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    SocketListner.disconnect();
  },

};
</script>

<style scoped>
.chatpage {
  height: calc(100vh - 116px);
  overflow: auto;
  padding-top: 2rem;
  display: flex;
  flex-direction: column-reverse;
}

</style>
